import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AgGridRequest } from '@app/shared/models/ag-grid-request';
import { AllAssessmentControlsResponse } from '@app/operational-rates/models/responses/all-assessment-controls-response';
import { ActionAssessmentControlAuthorisationRequest } from '@app/operational-rates/models/requests/action-assessment-control-authorisation-request';
import { CreateAssessmentControlRequest } from '@app/operational-rates/models/requests/create-assessment-control-request';
import { AssessmentControlsMetadataResponse } from '@app/operational-rates/models/responses/assessment-controls-metadata-response';
import { GeneratedReport } from '@app/fin-ops/models/generated-report';
import { GetAnnuityValuesAtDateRequest } from '@app/operational-rates/models/requests/get-annuity-values-at-date-request';
import {
  AnnuityValuesTemplateUploadRequest,
  RequestAnnuityValuesAuthorisationRequest,
} from '@app/operational-rates/models/requests/request-annuity-values-authorisation-request';
import { AnnuityValuesMetadataResponse } from '@app/operational-rates/models/responses/annuity-values-metadata-response';
import { PendingAnnuityValuesResponse } from '@app/operational-rates/models/responses/pending-annuity-values-response';
import { ActionAnnuityValuesAuthorisationRequest } from '@app/operational-rates/models/requests/action-annuity-values-authorisation-request';
import { GroupedAnnuityValuesResponse } from '@app/operational-rates/models/responses/grouped-annuity-values-response';
import { AnnuityValueControlResponse } from '@app/operational-rates/models/responses/annuity-value-control-response';
import { GroupedAnnuityValueOnControlResponse } from '@app/operational-rates/models/responses/grouped-annuity-value-on-control-response';

export const opsRatesActionPrefix = '[Operations Rates]';
export const getAssessmentControls = createActionGroup({
  source: `${opsRatesActionPrefix} Get All Assessment Controls `,
  events: {
    do: props<{ request: AgGridRequest<AllAssessmentControlsResponse> }>(),
    success: emptyProps(),
    failure: emptyProps(),
  },
});

export const exportAssessmentControls = createActionGroup({
  source: `${opsRatesActionPrefix} Export Assessment Controls `,
  events: {
    do: props<{ request: AgGridRequest<AllAssessmentControlsResponse> }>(),
    success: emptyProps(),
    failure: emptyProps(),
  },
});
export const createAssessmentControl = createActionGroup({
  source: `${opsRatesActionPrefix} Request Assessment Control`,
  events: {
    do: props<{
      request: CreateAssessmentControlRequest;
      successCallBack: () => void;
    }>(),
    success: emptyProps(),
    failure: props<{ error: string }>(),
  },
});

export const actionAssessmentControl = createActionGroup({
  source: `${opsRatesActionPrefix} Action Assessment Control`,
  events: {
    do: props<{
      request: ActionAssessmentControlAuthorisationRequest;
      successCallBack: () => void;
    }>(),
    success: emptyProps(),
    failure: props<{ error: string }>(),
  },
});

export const getAssessmentControlsMetadata = createActionGroup({
  source: `${opsRatesActionPrefix} Get Assessment Controls Metadata`,
  events: {
    do: emptyProps(),
    success: props<{ metadata: AssessmentControlsMetadataResponse }>(),
    failure: props<{ error: string }>(),
  },
});
export const downloadExcelExport = createActionGroup({
  source: `${opsRatesActionPrefix} Download excel report`,
  events: {
    do: props<{ report: GeneratedReport }>(),
    success: emptyProps,
    failure: emptyProps,
  },
});
export const getAnnuityValuesAtDate = createActionGroup({
  source: `${opsRatesActionPrefix} Get Annuity Values At Date `,
  events: {
    do: props<{ request: GetAnnuityValuesAtDateRequest }>(),
    success: props<{ annuityValues: GroupedAnnuityValuesResponse[] }>(),
    failure: props<{ error: string }>(),
  },
});
export const exportAnnuityValues = createActionGroup({
  source: `${opsRatesActionPrefix} Export Annuity Values`,
  events: {
    do: props<{ request: GetAnnuityValuesAtDateRequest }>(),
    success: emptyProps(),
    failure: emptyProps(),
  },
});
export const requestAnnuityValues = createActionGroup({
  source: `${opsRatesActionPrefix} Request Annuity Values`,
  events: {
    do: props<{ request: RequestAnnuityValuesAuthorisationRequest }>(),
    success: emptyProps(),
    failure: props<{ error: string }>(),
  },
});

export const getAnnuityValuesTemplate = createActionGroup({
  source: `${opsRatesActionPrefix} Get Annuity Values Template`,
  events: {
    do: emptyProps(),
    success: emptyProps(),
    failure: emptyProps(),
  },
});
export const getAnnuityValuesFromTemplate = createActionGroup({
  source: `${opsRatesActionPrefix} Get Annuity Values From Template`,
  events: {
    do: props<{ request: AnnuityValuesTemplateUploadRequest }>(),
    success: props<{ annuityValues: GroupedAnnuityValuesResponse[] }>(),
    failure: props<{ error: string }>(),
  },
});
export const getAnnuityValuesMetadata = createActionGroup({
  source: `${opsRatesActionPrefix} Get Annuity Values Metadata`,
  events: {
    do: emptyProps(),
    success: props<{
      metadata: AnnuityValuesMetadataResponse;
    }>(),
    failure: props<{ error: string }>(),
  },
});

export const getPendingAnnuityValues = createActionGroup({
  source: `${opsRatesActionPrefix} Get Pending Annuity Values`,
  events: {
    do: emptyProps(),
    success: props<{
      pendingAnnuityValues: PendingAnnuityValuesResponse;
    }>(),
    failure: props<{ error: string }>(),
  },
});

export const actionAnnuityValues = createActionGroup({
  source: `${opsRatesActionPrefix} Action Annuity Values`,
  events: {
    do: props<{
      request: ActionAnnuityValuesAuthorisationRequest;
    }>(),
    success: emptyProps(),
    failure: props<{ error: string }>(),
  },
});

export const loadAnnuityValueControls = createActionGroup({
  source: `${opsRatesActionPrefix} Load Annuity Values Controls`,
  events: {
    do: props<{
      request: AgGridRequest<AnnuityValueControlResponse>;
    }>(),
    success: emptyProps(),
    failure: emptyProps(),
  },
});

export const loadAnnuityValueGroupedByControl = createActionGroup({
  source: `${opsRatesActionPrefix} Load Annuity Values Grouped by Control`,
  events: {
    do: props<{
      request: AgGridRequest<GroupedAnnuityValueOnControlResponse>;
    }>(),
    success: emptyProps(),
    failure: emptyProps(),
  },
});
